<div id="page-with-shimmer" class="flex-page" *ngIf="!templateError">
  <ids-mobile-header [headingElement]="bgBaseH1" class="ids-theme-change">
    <button
      id="first-access-screen"
      idsMobileHeaderAction
      tabindex="0"
      role="button"
      [attr.aria-label]="labelBtnBack"
      (click)="logout()"
      (focus)="ariaLabelPage = false"
    >
      <ids-icon>seta_esquerda</ids-icon>
    </button>
    <h1 #bgBaseH1 class="cdk-visually-hidden" aria-hidden="true"></h1>
  </ids-mobile-header>

  <ion-content class="shimmer" [attr.aria-hidden]="ariaLabelPage">
    <div class="img-label-content-first">
      <img
        src="../../../assets/images/svg/first-access-icon.svg"
        alt="icon"
        aria-hidden="true"
      />
    </div>

    <h1 class="ids-title -small -bold title-pg">
      Estamos quase lá! Agora é hora de você aceitar nossos termos de uso.
    </h1>

    <p class="ids-body-text description-pg">
      Ao continuar, você aceita nossos Termos de uso e política de privacidade
      do App.
    </p>

    <button
      class="ids-theme-change ids-link link-pg"
      role="button"
      tabindex="0"
      [attr.id]="idLink"
      [attr.aria-label]="'abrir termos de uso e Política de Privacidade'"
      (click)="getTerm({ type: listTerms[0].type, index: idLink })"
    >
      Termos de uso
      <ids-icon size="S" class="ids-icon link-pg__icon" aria-hidden="true">
        <span aria-hidden="true">seta_direita</span>
      </ids-icon>
    </button>
  </ion-content>

  <div class="area-button" [attr.aria-hidden]="ariaLabelPage">
    <button
      idsMainButton
      full="true"
      class="ids-theme-change"
      [ngClass]="{ 'loading-custom': loadingVerify }"
      [attr.aria-label]="loadingVerify ? 'Carregando página' : 'Continuar'"
      (click)="clickNext()"
    >
      <span *ngIf="!loadingVerify">Continuar</span>
      <ids-icon
        size="S"
        class="ids-icon link-pg__icon"
        aria-hidden="true"
        *ngIf="!loadingVerify"
      >
        <span aria-hidden="true">seta_direita</span>
      </ids-icon>

      <div aria-hidden="true" class="ids-button__loader" *ngIf="loadingVerify">
        <ids-loading size="S" contrast="onBrand"></ids-loading>
      </div>
    </button>
  </div>
</div>

<app-template-error
  *ngIf="templateError"
  [type]="'generic'"
  [loadingButton]="loadingVerify"
  [focusBtnHeader]="focusBtnHeaderError"
  [showBtnTryAgain]="showBtnTryAgain"
  (tryAgainBtnClick)="sendUserData()"
  (closeBtnClick)="logout()"
>
</app-template-error>

<app-loading-circle *ngIf="loading"></app-loading-circle>
<div class="sr-only" *ngIf="alertVoiceOver" aria-live="assertive">
  Carregando página
</div>
